import React from "react"
require("typeface-roboto-mono")


export default ({ children }) => (
  <div style={{ margin: `2rem auto`, marginBottom:'3rem', maxWidth: 650, padding: `0 1rem` }}>
    {children}
  </div>
)



